import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  list: [],
  current: {},
  loading: false,
  pagination: {},
};

const formsReducer = createReducer(initialState)({
  // GET FORMS
  [types.FETCH_FORMS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_FORMS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      list: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_FORMS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
});

export default formsReducer;
